import { SELLERS_VIEW_ACTIONS } from '../actions';

const initState = ({ sellers = [], total = 0, hasMorePages = false, lastItemId }) => ({
    sellers,
    total,
    hasMorePages,
    lastItemId,
});

const sellersViewReducer =
    (sellersData) =>
    (state = initState(sellersData), action = {}) => {
        const { type, data } = action;

        switch (type) {
            case SELLERS_VIEW_ACTIONS.SET:
                return {
                    ...state,
                    sellers: data.sellers,
                    hasMorePages: data.hasMorePages,
                    lastItemId: data.lastItemId,
                };
            default:
                return state;
        }
    };

export default sellersViewReducer;
